import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M107.98 41.87C107.98 41.87 80.3505 27.42 78.9505 25.66C77.5505 23.9 76.6105 1 76.6105 1H54.6005C54.6005 1 53.6605 23.9 52.2605 25.66C50.8605 27.42 23.2305 41.87 23.2305 41.87C23.2305 41.87 35.4805 56.92 65.6105 56.92C95.7405 56.92 107.98 41.87 107.98 41.87Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M121.7 47.57C118.62 43.94 84.06 26.76 84.06 26.76L65.61 47.39L47.16 26.76C47.16 26.76 12.6 43.93 9.52002 47.57C6.44002 51.2 2 72.72 2 72.72H129.23C129.22 72.71 124.78 51.2 121.7 47.57Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M45.3396 31.83C29.6796 39.67 14.1496 48.02 12.1496 50.09C10.8796 51.65 8.31956 60.65 6.32956 69.44L5.94955 71.63H3.30957C3.30957 71.63 7.92955 50.82 10.1595 48.18C12.3895 45.54 42.8596 30.01 42.8596 30.01L45.3396 31.83Z"
        fill="white"
      />
      <path
        d="M88.1899 30.01C88.1899 30.01 118.66 45.53 120.89 48.18C123.12 50.83 127.74 71.63 127.74 71.63H125.1L124.72 69.44C122.73 60.65 120.18 51.65 118.9 50.09C116.9 48.02 101.37 39.68 85.71 31.83L88.1899 30.01Z"
        fill="white"
      />
      <path d="M47.8304 36.24L25.6904 72.51" stroke={outline} strokeMiterlimit="10" />
      <path d="M82.6602 37L105.52 72.51" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M69.9601 71.71V65.24H61.7801V68.93H54.5801V63.77L60.3401 57.87H71.4001L77.1601 63.77V71.72H69.9601V71.71Z"
        fill="white"
      />
      <path
        d="M88.9398 30.32L65.6298 56.6L42.0898 30.43L46.8398 27.99L65.5698 48.96L84.2998 27.99L88.9398 30.32Z"
        fill="white"
      />
      <path
        d="M44.2695 28.8L65.6295 52.65L86.9995 28.76"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        fill="none"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="65.6067"
          y1="32.3967"
          x2="65.6067"
          y2="21.9013"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
